import React, {useContext, useEffect} from 'react';
import "../map/CrimeMap.css";
import {makeStyles} from '@material-ui/core/styles';
import FilterPanel from './FilterPanel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import FilterContext from '../FilterContext';
import {Container} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: 'left',
        padding: '0.5rem 1rem'
    }
}));

function DateFilters(props) {
    const classes = useStyles();

    const [context, setContext] = useContext(FilterContext);

    const [startDate, setStartDate] = React.useState(Date.parse(context.filters.start));
    const [endDate, setEndDate] = React.useState(new Date());

    const isValidDate = (date) => date instanceof Date && !isNaN(date)

    const handleStartDateChange = (date) => {
        if (isValidDate(date)) {
            setStartDate(date);
            setContext({...context, filters: {...context.filters, start: date.toISOString()}})
        }
    };
    const handleEndDateChange = (date) => {
        if (isValidDate(date)) {
            setEndDate(date);
            setContext({...context, filters: {...context.filters, end: date.toISOString()}})
        }
    };

    const [range, setRange] = React.useState('custom');

    const handleChange = (event) => {
        setRange(event.target.value);
        const newStart = new Date();
        if (event.target.value === "yesterday") {
            newStart.setDate(newStart.getDate() - 1);
            setStartDate(newStart);
        } else if (event.target.value === "3-days") {
            newStart.setDate(newStart.getDate() - 3);
            setStartDate(newStart);
        } else if (event.target.value === "week") {
            newStart.setDate(newStart.getDate() - 7);
            setStartDate(newStart);
        } else if (event.target.value === "month") {
            newStart.setMonth(newStart.getMonth() - 1);
            setStartDate(newStart);
        }
        const newEnd = new Date();
        setEndDate(newEnd);

        setContext({
            ...context, filters: {
                ...context.filters,
                start: newStart.toISOString(),
                end: newEnd.toISOString()
            }
        })
    };

    const timeRanges = [{value: "yesterday", label: "Yesterday"},
        {value: "3-days", label: "Last 3 Days"},
        {value: "week", label: "Last Week"},
        {value: "month", label: "Last Month"},
        {value: "custom", label: "Custom Range"}];

    return (
        <FilterPanel sidebarWidth={props.sidebarWidth} selected={props.selected} close={props.close}>
            <Container>
                <FormControl component="fieldset">
                    <h3>Time Range</h3>
                    <RadioGroup aria-label="date range" name="date-range" value={range} onChange={handleChange}>
                        {timeRanges.map((timeRange) => (
                            <FormControlLabel key={timeRange.value} value={timeRange.value} control={<Radio color="primary"/>} label={timeRange.label}/>
                        ))}
                    </RadioGroup>
                </FormControl>
                <div style={{display: range === "custom" ? "block" : "none"}}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            label="From"
                            value={startDate}
                            onChange={handleStartDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                        <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            format="MM/dd/yyyy"
                            margin="normal"
                            label="To"
                            value={endDate}
                            onChange={handleEndDateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </div>
            </Container>
        </FilterPanel>
    );
}

export default DateFilters;
